export const m = {
    about: '关于我们',
    Cooperationsupport: '合作支持',
    Partners: '合作伙伴',
    CompanyOverview: '公司概况',
    Legaldocument: '法律文件',
    Instruments: '交易产品',
    Commodities: '商品',
    Forex: '外汇',
    Index: '指数',
    Options: '数字币',
    Platform: '交易平台',
    LoginTrade: '登录交易',
    Platformintroduced: '平台介绍',
    DownloadCenter: '下载中心',
    Support: '培训支持',
    News: '新闻资讯',
    Companynotice: '公司公告',
    IndustryNews: '行业新闻',
    EconomicCalendar: '财经日历',
    FinancialNews: '财经快讯',
    Login: '登录',
    Register: '注册',
    Retrading: '一键交易全球',
    Singledd: '一个账户可以跨市场跨品种交易',
    Fastedd: '快速、简洁的交易平台',
    transparentsd: '安全、公平、透明的交易环境',
    Integratingntsd: '金融与科技的融合',
    Regulatoryd: '持有多个国家的金融监管牌照',
    Starttrading: '开始交易',
    Openanaccount: '开设账户',
    Latestnews: '最新消息',
    Announcement: '公告',
    Various: '多个交易品种多个市场',
    ReadMore: '了解更多',
    platformsw: '快速、稳定的交易平台',
    lcgGsw: 'BP MarketsGO普通投资者的首选',
    lSimplecgGsw: '简单、快捷、易用的平台，所有品种触手可及',
    lapplicationecgGsw: 'BP MarketsGO是一款基于网络的应用程序，适合PC端或移动端的网页登录交易',
    ClientDownloads: '客户端下载',
    Cdesignedds: 'BP MarketsGO适合所有投资者',
    offerwe: '我们提供可在PC或移动端下载安装的交易平台',
    through: '无论您身在何地，都可以通过安装下载交易平台进行交易',
    DownloadApps: '手机端下载',
    time: '时间',
    Currency: '币种',
    Important: '重要性',
    Activity: "活动",
    This: '今值',
    Predictive: '预测值',
    Before: '前值',
    withtrading: '携手BP Markets开始交易',
    applications: '选择一个账户并提交您的申请',
    Funding: '入金',
    Fastsg: '通过借记卡或银行卡转账快速安全地注资',
    Trade: '交易',
    Accessse: '访问 商品、外汇、指数、期权等交易品种和交易方式',
    Tools: '工具',
    PrivacyPoilcy: '隐私条款',
    Disclaimer: '免责申明',
    RiskWarning: '风险提示',
    Useragreement_01: "用户协议",
    Contactus: "联系我们",
    investment: "您的投资价值可能上涨，也可能下跌。在保证金交易中，损失有可能超过保证金甚至是大部分本金。高杠杆意味着高风险，您应仔细考虑您的风险承受能力和对杠杆交易的理解程度。",
    transactionsw: "您必须认识到，风险不仅包含交易风险，还包括一些不可抗力因素所造成的风险，比如：网络中断，政治动乱、黑客攻击等。",
    Parklifesdee: "BP Markets拥有本网站的所有权和使用权，是全美期货协会（NFA）会员，编号 0525014，受美国金融业监管局（FINRA）监管。获得美国财政部数字货币交易许可，许可证号31000154458901，查询链接 https://www.fincen.gov/msb-state-selector。",
    accessibledee: "本网站可在全球范围内访问，网站上所有的信息仅供参考，并不构成指引性建议，对于任何人依据本网站或网站的信息采取的作为或不作为所导致的后果，我们不承担任何责任。",
    acoverageledee: "涵盖黄金、白银、原油、铜等主要活跃品种",
    Relatively: "相对较低的保证金",
    instrumentsely: "商品具有较高的流动性和波动率",
    professionalumentsely: "提供专家观点和在线教育服务",
    dollaref: "涵盖所有美元货币对和大部分非美货币对",
    largest: "全球最大的交易市场，每日交易量超过5万亿美金",
    Effective: "有效的对冲汇率波动和地缘政治风险",
    intradays: "日内丰富的交易机会",
    countriesw: "涵盖主要国家、地区的股票指数",
    Indexcontracts: "指数合约可以有效的对冲股票交易风险",
    Inrepresentscts: "股票指数代表了相应交易所的主要股票水平",
    leveraging: "较少的资金撬动较大的交易规模",
    leforeigng: "涵盖商品、外汇、指数，股票等标的",
    risksng: "锁定风险的交易方式",
    purchsases: "期权购买的是一种标的在合约期内杠杆性收益的权利",
    Effectiver: "有效的对冲相关标的其他交易方式的风险",
    Become: "成为世界顶尖交易平台的顶级经济商",
    BecExploreome: "一起开拓世界",
    unlock: "成为BP Markets经济商，解锁更多交易机会",
    unlChooseock: "选择合作伙伴方案",
    partnership: "BP Markets根据您的需求提供多种合作方案",
    Broker: "经纪商",
    Brorebateker: "定制的返佣方案和灵活结算方式",
    Receiveateker: "外汇主要货币对：交易每百万美金，佣金高达50美金",
    etfs: "大宗商品、指数合约、ETF、期权：多种交易品种，多种交易模式，满足客户的所有需求",
    Dealers: "交易商",
    Deaschemeslers: "根据您的需求提供返佣方案",
    conditions: "市场顶级交易条件与独有宣传资料",
    businesss: "多语言专业支持，为您扩展业务提供支持",
    accuratedf: "BP Markets代理后台为代理提供准确客户信息，表现报告以及佣金详情",
    informaqtions: "如需获取关于合作伙伴类型与返佣方案的更多信息，请点击下载",
    table: "申请表",
    and: "和",
    Brokeragreement: "经纪商协议",
    required: "并将其与所需文件一起邮寄或电子邮件发送给我们，电子邮箱：support@bp-markets.com",
    reqWhyuired: "为何选择BP Markets？",
    transactions: "通过一家安全的以客户为中心的供应商进行外汇交易",
    AboutPLCG: "关于BP Markets",
    constructionwe: "我们致力于金融科技和交易生态的构建，为用户提供丰富多彩的全球化交易体验",
    consaccount: "一个账户，一个世界",
    Whatwedo: "我们的服务",
    build: "我们搭建数字平台以促进多资产市场准入，并为各种规模的客户提供专业级工具、行业领先的价格和世界一流的服务",
    lnvestments: "投资和交易",
    foreignq: "通过一个账户，交易商品、外汇、指数、期权等合约产品，捕捉各个市场和品种的投资机会",
    Partnerships: "合作伙伴关系",
    bankingps: "通过开放式银行解决方案，我们为 120 多家银行和经纪商以及 300 多家金融中介机构提供支持，为他们提供多资产执行、主经纪商服务和交易技术",
    Licensedfg: "持牌、安全、稳定",
    ssociat: "拥有全美期货协会（NFA）牌照，席位号为0525014（了解我们的持牌情况）",
    ssocchoosingiat: "当您选择我们，您是选择在一个受严格监管的平台上进行交易，以确保您交易的公正性。",
    Financiaecurity: "资金安全保障",
    securityurity: "资金安全对于交易者至关重要，确保投资者资金得到监管国家全方位严格监管。",
    sPowerfulurity: "强大的交易平台",
    accountrity: "一个账户交易多个市场品种，不论您在何地，我们交易平台都保持强大的稳定性。",
    Integrated: "一体化的投资管理",
    Richproduct: "丰富的产品",
    Richpmarketsroduct: "通过一个账户交易多个市场和品种，我们从各大交易所获取深度流动性的优势",
    Stableplatform: "稳定的平台",
    Stexecuteatform: "快速执行交易指令，并不断优化执行体验，降低拒单率",
    Safetyguarantee: "安全的保障",
    fundsrantee: "客户资金受严格监管，网站和交易平台具备强大防攻击能力",
    Tradecommodities: "商品交易",
    Tradepreciouss: "可交易贵金属、原油、铜等大宗商品",
    environment: "公正的交易环境",
    envConnectironment: "实时对接各大交易所数据，为客户提供更具竞争力的价格优势",
    Transility: "交易灵活性",
    Trleveragelity: "我们的产品系列让您可以做多或做空，进行杠杆交易和对冲交易或对单个商品形成长远判断",
    Stablatform: "稳定的交易平台",
    mobilelatform: "通过手机、平板电脑、笔记本电脑或多屏桌面设置，您可以快速而有效地访问市场",
    expertse: "提供5X24小时的专家服务",
    professionaltse: "您可在任何市场开放时间获得专业支持，包括技术援助、市场分析以及联系您的个人销售交易员",
    Competitivealtse: "极具竞争力的商品合约定价",
    InstrumentName: "合约名称",
    ContractName: "合约规格",
    ounces: "盎司",
    barrels: "桶",
    pounds: "磅",
    Spread: "点差",
    Initialmargin: "即市保证金",
    Limitrgin: "单笔交易手数（手）",
    Positionn: "单边持仓显示（手）",
    Strongq: "强大稳定的交易平台",
    derivatives: "衍生品交易首选平台",
    dWebvatives: "网页端和下载端无缝对接",
    Multseiple: "多种工具和功能",
    indicatorsle: "各类分析指标助力您的交易",
    varietyle: "丰富的交易品种",
    foreignw: "使用同一个账户交易商品、外汇、指数、数字币合约等产品",
    Moreinformation: "常见问题解答",
    eventsion: "Q1. 商品领域应该关注哪些数据或新闻事件？",
    mainlyion: "商品主要关注欧美国家的政治经济动态，关注的主要数据有：美国非农数据、EIA、欧佩克会议等",
    deliveryion: "Q2. 你们是否实物交割？",
    contractsw: "我们不提供实物交付。期货合约或期权合约将在交割期或到期日自动平仓。",
    informatitsw: "Q3. 哪里可以了解到实时的信息？",
    providedwq: "在我们新闻资讯里可以查看到财经日历和快讯，财经日历和快讯为第三方提供，并不代表我们观点或构成建议。",
    advicefe: "Q4. 是否提供操作建议？",
    reprweesent: "我们不提供具体的操作建议，我们的专家发表的观点或知识仅代表其个人或团队，不构成交易依据。",
    Tradeorex: "外汇交易",
    currencyrex: "可交易全部美元货币对和非美货币对",
    Competitiveex: "极具竞争力的外汇合约定价",
    eventser: "Q1. 外汇领域重点关注哪些事件？",
    dollareventser: "美元货币对主要关注美国的政治经济政策，主要关注美联储的利率政策；非美货币对主要关注相关国家的利率政策和政治经济变动。",
    indexesntser: "可交易欧洲、美国、亚洲国家或地区股票指数,",
    Asianntser: "主要包含标普500，纳指、恒指、德指，富时A50等",
    Competitives: "极具竞争力的指数合约定价",
    shouldves: "Q1. 交易指数应该注意哪些？",
    whethers: "指数代表了相对应国家的股票市场水平，主要关注相关国家的股市是牛市还是熊市或者说经济是整体扩张上行的还是萎缩下滑的。",
    whetactivehers: "BP MarketsGO 是我们屡获殊荣的交易平台，无论您是长期投资者还是全球市场上的活跃交易者，该平台都能让您主宰自己的交易。",
    accessrs: "借助 BP MarketsGO，您可以访问所有可交易的金融工具和多种风险管理工具，并能获取相应功能以在任意 PC、平板电脑或智能手机上迅速直观地执行交易。",
    featuressrs: "主要特点",
    Mobility: "移动性",
    seamlesslyty: "在不同设备之间无缝移动，随时随地管控您的投资。 在智能手机上开始，然后在平板电脑上继续，最后在台式机上完成。 设置和偏好将随您转移，您始终可以接着进行设定。",
    Keepdate: "掌握最新信息",
    economicte: "获取新闻推送、市场数据、经济信息发布和实时图表。 标注图表、使用技术分析工具以及监管您需要获取的信息，从而确保高效交易。",
    Intuitivete: "直观交易",
    fastivete: "界面快捷、可靠且直观。 不会陷入交易运作方式的泥沼中。 从图表或专属交易模块进行交易。 作出交易决策之后，可迅速执行交易而无需思考执行方式。",
    specifications: "平台特色和规格",
    Standions: "支持",
    Sservicesions: "BP Markets提供5*24小时的在线或电话支持服务。 可随时从平台上访问支持服务台。",
    Oneesions: "一个账户",
    yourions: "通过 BP MarketsGO 访问您的账户，你可在PC和移动端无缝连接。",
    Information: "信息",
    pushtion: "从推送通知到新闻频道，只需一个平台，您就可以进入全球金融市场。",
    puCrossshtion: "跨资产类别交易",
    includingion: "交易BP Markets的所有资产，包括大宗商品、外汇、指数、数字货币。",
    Reliability: "可靠性",
    reliablfe: "BP MarketsGO 稳定可靠，能让您随时随地进行交易。",
    Availability: "可用性",
    iOSty: "支持所有iOS设备",
    iOSdesktopty: "在台式机上访问浏览器",
    Androids: "支持所有安卓设备",
    mobileids: "在移动设备上访问浏览器",
    chooseeids: "为何选择我们的交易app ？",
    major: "专为所有主流手机和平板电脑设计",
    updatedsd: "定期更新，尽可能为您提供最佳交易体验",
    Completelyd: "完全免费下载",
    encryptiond: "采用安全的256位SSL加密，让您放心交易",
    exclusiveb: "获取有关外汇、股票和指数等市场的独家数据和分析",
    analysise: "无需登录即可查看实时价格的独家数据和分析",
    terminal: "随时随地 多平台终端交易",
    tefunctionrminal: "覆盖iOS、Android、Windows、Mac多个平台，支持全业务功能",
    thousandsminal: "上万市场，尽在指尖",
    tallowssminal: "我们的移动交易应用程序可让您交易丰富的金融市场，例如：",
    largestal: "参与全球最大的大宗商品交易市场，品种涵盖黄金、白银、原油等。",
    lforeignstal: "低点差交易多种外汇货币对，包括欧元/美元、英镑/美元、欧元/英镑等主流货币对",
    Nasdaq: "交易丰富环球股指，更可24小时交易恒生指数、纳斯达克指数、标普500指数等",
    Namethodsdaq: "锁定风险的交易方式，有效对冲相关标的其他交易方式的风险",
    tradingcfd: "何为CFD交易",
    risksgcfd: "CFD交易有何风险",
    transactionss: "CFD差价合约可用于哪些交易",
    suitablede: "CFD交易是否合适我",
    suitradede: "关于交易",
    onlineradede: "关于在线交易",
    CFDede: "什么是差价合约交易？",
    speculating: "差价合约(CFD)交易是通过买卖差价合约，对金融市场的走势进行预测，但并不实际买入或卖出任何标的资产的交易。",
    financialing: "差价合约(CFD)是同意就某资产自合约建仓直至平仓时的价值差进行交易的协议，是一种金融衍生品交易类型。",
    Latesting: "BP Markets最新财经资讯",
    interpretationing: "实时更新，第一手资讯，第一秒解读",
    inttradingg: "什么是价差合约交易",
    risksg: "价差合约有哪些风险",
    transactionss: "价差合约用于哪些交易?",
    suitableed: "差价合约交易适合我吗？",
    contractsd: "差价交易合约（CFD）是一种在金融市场上进行投机的方式，不需要买卖任何基础资产。 找出了解CFD交易所需的一切，从它的内容以及它如何工作到做空交易，杠杆和对冲。",
    definedsd: "差价合约交易被定义为“差价合约的买卖”，“差价合约”的意思是“差价合约”。 差价合约是一种衍生产品，因为它们使您无需持有基础资产的所有权即可在股票，外汇，指数和商品等金融市场上进行投机。",
    dwhenefinedsd: "相反，当您交易差价合约时，即表示您同意交换资产价格（从合约开立点到合约结束时）的差额。 差价合约交易的主要好处之一是，您可以推测任一方向的价格变动，并根据预测的正确程度来确定损益。",
    Shortd: "短期和长期差价合约交易说明",
    Senablesrtd: "在CFD交易中，您可以推测两个方向的价格变动。因此，我们可以模仿市场价格上涨后获利的传统交易，但也可以打开原资产市场价格下跌后获利的CFD位置。它被称为“卖”或“短”，而不是购买或“长”。",
    thinkblesrtd: "例如，如果您认为苹果股票的价格将下跌，则可以出售该公司的股票差价合约。 您仍然可以交换开仓和平仓之间的价格差，但是如果股价下跌，则将获利，如果股价上涨，则将获利。",
    profits: "无论是多头还是空头，平仓后都会实现盈亏。",
    Learnts: "了解如何交易差价合约",
    LeLeveragearnts: "差价合约交易杠杆解释",
    whichrnts: "差价合约交易是杠杆交易，这意味着您无需承担全部费用即可获得大量头寸。 假设您想开设一个相当于500股苹果股票的头寸。 对于标准交易，这意味着要先支付全部股票费用。 另一方面，有了差异合同，您可能只需要承担5％的费用。 了解有关差价合约和股票交易之间差异的更多信息。",
    enablesnts: "尽管杠杆使您可以进一步分散资本，但是请务必记住，您的盈亏仍将根据头寸的全部规模进行计算。 在我们的示例中，这就是从您开始交易到结束交易时500股苹果股票的价格差。 这意味着与您的支出相比，损益都可以被极大地放大，并且损失可能超过存款。 因此，重要的是要注意杠杆比率，并确保您在自己的能力范围内进行交易。",
    explainede: "保证金解释",
    sometimesk: "杠杆交易有时称为“保证金交易”，因为开设和维持头寸所需的资金（“保证金”）仅占其总规模的一小部分。",
    stypesometimesk: "交易差价合约时，有两种保证金类型。 开仓需要保证金，而如果您的交易几乎蒙受了亏损，而保证金和您账户中的任何额外资金将无法弥补，则可能需要维持保证金。 如果发生这种情况，您可能会收到提供商的追加保证金通知，要求您补充帐户中的资金。 如果您没有增加足够的资金，该头寸可能会被平仓，并且所产生的任何损失都将被兑现。",
    explainedq: "对冲差价合约的解释",
    expusedlainedq: "差价合约也可以用来对冲现有投资组合中的损失。",
    exampledq: "例如，如果您认为投资组合中的一些ABC Limited股票可能由于令人失望的收益报告而遭受短期价值下跌的冲击，则可以通过差价合约交易在市场上做空来抵消部分潜在损失 。 如果您确实决定以这种方式对冲风险，则您的投资组合中ABC Limited股票价值的任何下跌都将被您的差价合约差价合约交易的收益所抵消。",
    erisksxam: "差价合约有哪些风险？",
    marketsam: "了解金融市场交易涉及的风险，并了解如何使用我们广泛的工具和资源来控制风险。",
    financialam: "差价合约与任何金融产品一样具有风险–如果市场变化对您没有帮助，您将蒙受损失。 但是，差价合约是杠杆产品，因此可能涉及更高的风险。",
    leverageialam: "什么是杠杆？",
    allowsam: "利用杠杆，您可以用相对较少的资本投资就可以在金融市场上获得更大的投资头寸，换句话说，杠杆可以增加损益的范围。",
    allhigherowsam: "杠杆交易的风险更高吗？",
    capital: "尽管开立头寸所需的资金数额较小，但您的收入或损失是根据头寸的全部价值计算的。",
    capThereforeital: "因此，您的收入或损失金额可能相对高于您的初始投资金额。",
    controlledtal: "风险极限可以控制吗？",
    managetal: "是的，我们提供了一系列工具来帮助您管理未结头寸和控制风险限额。",
    Developk: "制定并严格遵守交易计划",
    Dachievee: "交易计划可以帮助您清楚地定义和实现总体金融交易目标。",
    expertiseee: "逐步培养技能和专业知识",
    leverageeee: "如果您刚开始使用杠杆产品，则可以尝试一下以了解杠杆的工作原理，并加深对杠杆的了解。",
    Understande: "了解您感兴趣的交易市场",
    factorsvf: "确保您了解影响不同市场的因素，以便根据最相关的信息制定交易策略。",
    Observesvf: "观察您的空缺职位",
    positionsf: "从理论上讲，您可以持续观察您的未平仓合约并响应市场变化； 但是，这通常很难实现。",
    tabletsf: "我们的免费应用程序链接到我们的平台，使您可以使用手机或平板电脑查看交易。 您还可以通过设置价格警报来通知您达到指定价格的时间。",
    marketf: "使用止损和限制价格以避免市场干扰",
    sudden: "如果您无法及时应对市场的突然变化，则可能会蒙受损失。 如果市场出现“故障”，那么在没有交易的情况下它将跳涨跌落。 差距的原因可能是：市场",
    sabnormaludden: "收盘后，隔夜交易价格发生变化； 或在市场交易日发生异常事件。",
    protectn: "当市场突然变化时，我们的风险管理工具可以为您提供保护，而当市场变化对您有利时，您可以锁定利润。",
    protlimitectn: "这些包括止损，止损，尾随止损和限价单。",
    learningbg: "保持学习",
    understanding: "通过深入了解交易市场并探索新的交易策略来提高成功率。",
    transactionsrf: "差价合约差价合约可以用于什么交易？",
    multiplensrf: "差价合约可以在一个平台上交易多个市场。 以下是有关差价合约交易所涉及市场的详细信息，包括指数，股票，外汇等。",
    reflectsrf: "指数是一个数字，它反映特定交易所上一组资产的价格表现。 由于股票价格指数不交易有形资产，因此交易指数的唯一方法是通过反映其价格的产品（例如指数差价合约）。",
    rwhichsrf: "指数差价合约是一种交易形式，其中一定数量的现金根据标的股票价格指数进行交换并以当地货币购买。 例如，每张香港恒生50指数（HK50）合约的恒生指数定价为每点50港元。",
    worldwide: "我们的指数差价合约可以在全球范围内交易30多个指数，并且您可以一天24小时不间断地交易16个指数交易，而无需考虑交易所的正常交易时间。",
    wLearnorwide: "了解有关指数差价合约交易的更多信息>>",
    wLeaexchange: "外汇兑换",
    frequentlyange: "如何交易外汇？ 外汇交易是指通过赎回不同货币来获利的目的。 由于其高波动性和24小时交易，外汇交易是世界上交易最频繁的金融市场。",
    transactionsf: "由于外汇交易的变化相对较小，因此大多数散户投资者都使用杠杆交易。 外汇差价合约是交易外汇杠杆的有效方法。",
    actually: "您仍将以外汇货币对的形式进行外汇交易，对应于实际出售一种货币并购买另一种货币。 一份合约的价值取决于您交易的外汇货币对。 例如，GBP / EUR合约等于目标货币每点10欧元的变化，USD / JPY合约等于每点1000日元。",
    abouttually: "了解有关外汇差价合约交易的更多信息>>",
    ownershipk: "股票是特定公司的所有权单位。 股票的价值随公司价值的增加或减少而变化。 您可以在股市上买卖股票，但是股票差价合约交易可以享受各种出色的测试。",
    generally: "与其他市场不同，股票差价合约是按佣金而不是点差收取的。 一张合约通常等于一张股票，因此交易股票差价合约与在国际股票市场上交易股票非常相似。",
    Stock: "股票",
    Sttraditionalock: "但是，由于差价合约是根据基础资产价格变化进行交易的合约，因此股票差价合约比传统股票交易更灵活。 例如，通过经纪人卖空股票通常是一个复杂的过程，但是对于差价合约，卖空和卖空是相同的。",
    Option: "选项",
    indicesk: "有什么选择？ 期权是在指定时期内以指定价格（称为“行使价”）买卖市场的权利（并非义务）。 期权如何交易？ 我们的差价合约交易可以提供买卖指数和外汇的期权。",
    befospecificre: "买入或卖出期权使您有权在期权到期之前以特定价格购买差价合约差价合约。 我们还提供特殊形式的股票期权，这些股票不必实际交付任何股票即可参与期权的价格变动。",
    aboutficre: "了解有关期权差价合约交易的更多信息>>",
    Commodity: "商品",
    Commrefersodity: "商品交易是指利用金属和能源等商品的价格波动来获取利润。 由于商品的广泛使用和资源稀缺，商品已成为全球投资者青睐的投资选择。",
    commoditiesty: "在商品交易过程中，杠杆交易是大多数投资者的选择，而商品差价合约交易是商品交易的有力选择。",
    dependssty: "您仍将作为商品交易进行操作，单个合约的价值取决于您所交易的交易类型。 例如，一份黄金合约为100盎司，每次更改的价值为100美元。 WTI原油合约为1,000桶，每点价值10美元。",
    dcommodityty: "了解有关商品差价合约交易的更多信息",
    financialty: "如果您对金融市场运作有很好的了解并经常进行相关交易，则差价合约可能是您交易策略的重要组成部分。",
    newcomer: "我是交易新手",
    nthousandsomer: "差价合约交易使您无需花费大量初始资金即可进入数万个金融市场。",
    marketssomer: "股票交易佣金低，仅对大多数其他市场收费",
    positionmer: "完成头寸交易，初始保证金很小",
    Makeionmer: "充分利用市场的兴衰",
    indiceser: "可以开立外汇，指数，股票等头寸",
    idownser: "请注意，差价合约可能会导致超出预付款的损失，可能并不适合所有交易者",
    iforexdownser: "我是外汇交易员",
    ibelieveser: "如果您是活跃的外汇交易员，我相信您已经从外汇交易中受益。 通过差价合约与我们交易，您将获得更多利益。",
    serviceser: "直接外汇交易服务-直接进入交易所开始交易，掌握市场价差",
    seratiorviceser: "杠杆—我们的保证金比率低至0.5％",
    howiceser: "无论市场如何波动，保证止损都能为您的风险设定绝对限制",
    participateer: "可以参与超短期外汇交易的每日交易机会",
    foreignateer: "外汇交易没有重新报价",
    conditionsteer: "通过我们的各种移动交易应用程序掌握最新的外汇市场状况",
    portfoliocd: "在外汇投资组合之外探索贸易机会； 使用同一帐户在16,000个市场中交易",
    porthatiocd: "请注意，差价合约是杠杆产品。 通过差价合约进行外汇交易可能导致损失超过预付保证金，并且可能并不适合所有交易者。",
    alreadyhatiocd: "如果您已经在交易股票指数，CFD允许您一天24小时交易大量现货和期货市场。",
    indextiocd: "我是指数交易员",
    ibenefocd: "差价合约有什么好处？",
    istockocd: "股价涨跌都有获利的机会",
    indicescd: "交易超过30种全球指数",
    Tradingcdd: "交易24小时",
    Trflexibilitydd: "更大的灵活性",
    expirationtydd: "现货差价合约没有到期日",
    anytimeydd: "使用该应用随时随地进行交易和跟踪",
    margiwnd: "低保证金率可让您进行更多交易",
    supportd: "24小时客户支持",
    lossesd: "请注意，差价合约是杠杆交易，可能导致损失超过预付款。",
    stocklossesd: "我是一名股票交易员",
    knowledges: "借助差价合约，您可以利用现有的知识和股市研究方法，并利用杠杆来增加投资资本和对冲实物投资组合。 当然，您需要牢记与内部杠杆相关的风险。",
    Australianges: "在同一帐户中买卖澳大利亚和国际股票",
    increasees: "利用杠杆来增加投资资本",
    throughees: "通过非参与者直接配售通过市场价差进行交易",
    investmentes: "通过卖空保护您的实物投资组合，以避免受到不利的市场趋势的影响",
    minimumentes: "开户最低资金是多少？",
    mdeposittes: "要在BP Markets开户，最低入金为300美元。",
    kindes: "BP Markets提供什么样的杠杆作用？",
    kfixedindes: "BP Markets提供的杠杆是浮动的，保证金是固定的。",
    severales: "我可以在BP Markets开设多个帐户吗？",
    additiones: "BP Markets当前允许您开设真实账户，立即申请并立即开设。 此外，您可以开设多个模拟账户。",
    aclosingnes: "BP Markets的开闭时间是几点？",
    Americanes: "欧美DST",
    Saturdayes: "星期一上午7时至星期六凌晨4时",
    Closings: "关闭时间",
    Cleverydayosings: "每天凌晨5点至凌晨6点",
    Europeanbg: "欧美格林尼治标准时间",
    EuMondaybg: "从星期一早上7点到星期六早上5点",
    FromEuMondaybg: "每天早上6点至早上7点",
    provideaybg: "BP Markets提供多少种差价合约？",
    includingb: "BP Markets提供数十种CFDS进行交易，包括商品，外汇，指数等。有关详细信息，请访问BP Markets网站的产品页面。",
    indepositcludingb: "如何将资金存入我的帐户？",
    methowdsb: "BP Markets提供以下各种存款方法：",
    currhency: "数字货币场外交易",
    AliPayk: "通过支付宝付款",
    wpayment: "微信支付",
    Remittanceent: "中国银联汇款",
    depositsnt: "存款需要多长时间？",
    generallye: "通常是即时传输。",
    withdraw: "我如何提取资金？",
    withdrawal: "您只需要通过客户帐户中心的提款部分填写提款请求，即可提款。",
    wopen: "如何开设真实的BP Markets帐户？",
    simplewopen: "开设真实的BP Markets帐户非常简单。 打开“开设真实的BP Markets帐户”以填写并提交您的开设帐户申请。",
    submitpen: "开立真实的BP Markets帐户需要提交什么文件？",
    Accordingen: "根据美国国家期货协会（NFA）和美国金融业监管局（FINRA）的要求，BP Markets必须在与客户开设帐户之前确认客户的身份。",
    photogen: "您必须提交身份证和身份证照片以证明您的身份。",
    backgen: "身份证正面和反面",
    clearbackgen: "照片必须彩色打印且清晰。",
    numberckgen: "名称，身份证号码和有效期必须清晰可辨。",
    depositsen: "我可以从交易账户的存款中获得利息吗？",
    balanceen: "不会。BP Markets不支付客户资金余额的利息。",
    fundsbalanceen: "我可以将自己的资金转入朋友的银行帐户吗？",
    paymentceen: "不允许第三方存款和付款。",
    sameen: "模拟账户与真实账户相同吗？",
    squotationameen: "模拟账户和真实账户共享相同的报价来源，但是由于技术原因，它们无法享受相同的交易环境。 由于模拟账户的订单未进入真实交易市场，因此无法与真实账户进行比较。 模拟账户旨在使交易者熟悉交易平台，因此不会提供真实的交易经验。",
    bilateralen: "在CFDS交易中，您会看到双向报价。 出价是指您可以出售的基础货币的价格（同时购买非基础货币）； Ask是指您可以购买的基础货币的价格（同时出售非基础货币）。 买入和卖出之间的差额是点差，而交易商则从买入和卖出之间的差额中获利。",
    spreadalen: "点差是什么意思？",
    sonlinepreadalen: "我该如何在线交易？",
    provideen: "任何人都可以在世界各地进行在线交易。 我们为您提供专业级的BP MarketsGO平台，您可以在该平台上看到报价窗口，然后单击以通过浏览器进行交易。同时，您还可以在手机，平板电脑和其他移动设备上进行交易。",
    pendingvf: "什么是挂单？ 挂单有哪些类型？ 我可以在BP MarketsGO上设置挂单吗？",
    presetski: "挂单是指客户预设了价格和交易方向（出价或要价），并且只有在达到预设价格时才会进行交易。",
    ordersbg: "挂单有四种类型：",
    equalordersbg: "买入限价多头（低于当前价格）-当市场价格等于或低于预设价格时买入。",
    highersbg: "买入止损多头（高于当前价格）-当市场价格等于或高于预设价格时买入。",
    Sellhighersbg: "限价卖空（高于当前价格）-当市场价格等于或高于预设价格时卖出。",
    Stopersbg: "止损卖空（低于当前价格）-当市场价格等于或低于预设价格时卖出。",
    executedde: "BP MarketsGO允许设置挂单，这些挂单将存储在服务器上，并在满足条件时执行。",
    closingqw: "平仓保证金止损水平是多少？",
    namelyw: "BP Markets平台的保证金止损水平为30％，即当您的保证金水平低于100％时，系统将开始强制清算。 我们的关闭规则是，当帐户中资金的净值小于保证金的100％时，系统将关闭持有人帐户中的所有未平仓合约。",
    ntrendsamelyw: "さらに、市場が重要なデータや非農業データなどのニュースのリリースの急速な傾向にある場合、それはあなたの損失が証拠金ストップロスレベルを超えたり、口座残高がマイナスになることさえあります。",
    calculationlyw: "保证金水平的计算公式如下。",
    Usedlyw: "保证金水平=净值/已用保证金x 100％=保证金水平％",
    Forexample: "例如",
    valueple: "在净值为10,000美元的帐户中，持有1个标准手的美元/日元，其保证金计算如下：",
    caoppositeusing: "如果此趋势与您的持仓相反，导致您的净值跌至3000美元，",
    continuesng: "当趋势继续运行，导致您的净值下降到999美元时，您的帐户头寸将被强制关闭。 因为此时您的保证金水平是99.9％，低于指定的100％水平。",
    balancesuesng: "如何查看BP MarketsGO上的余额？",
    availablesng: "在BP MarketsGO上，您可以查看帐户中的实时余额，净值，保证金，可用保证金和保证金水平。 同时，您还可以查看实时损益。",
    periodng: "我的模拟账户有有效期吗？",
    validityng: "BP MarketsGO模拟账户的有效期为1个月。",
    limityng: "每月交易手数有下限吗？",
    monthlyf: "BP Markets对每月交易手数没有下限。",
    holdingvf: "同时持有订单是否有上限？",
    hoholding: "BP Markets的最大持仓数量为10手，累计最大持仓数量为100手。",
    holosses: "我的损失会超过我的初始存款吗？",
    liquidationw: "在BP MarketsGO平台上，我们建立了强制清算系统，也就是说，当您的保证金止损水平达到100％时，您的头寸将自动关闭。 该过程由系统自动执行，只要您的保证金水平达到预设水平，系统就会以下一个价格水平关闭所有头寸。",
    liimportant: "在某个特定时间或在发布重要数据（例如发布非农业数据）时，如果市场接近您的止损水平，而您的订单在市场上进行交易，则市场可能会出现空头缺口。 缺口之后的价格，您的帐户损失可能超过您的初始存款，这将导致负余额。",
    orderstant: "我可以保留订单多长时间？",
    interestsv: "您可以无限期保留订单，但必须有足够的资金来维持权益。",
    computersv: "我可以在同一台计算机上登录多个帐户吗？",
    Yescan: "是的你可以。",
    simultaneously: "我可以同时在不同的计算机上登录同一帐户吗？",
    sidownloadly: "如何用手机下载BP Markets平台？",
    sicodeadly: "扫描我们网站上的QR码以下载我们的交易平台APP。",
    accounts: "1.对于已有账户的客户，单击“我的”登录个人账户并申请开设真实账户或模拟账户；",
    Customersts: "2.没有帐户的客户，单击“我的” –“注册帐户”，您可以通过手机号码或电子邮件方便快捷地注册一个专用帐户，并使用我们的服务。",
    widerersts: "BP Markets对更广泛点差的政策是什么？",
    financialts: "价差扩大是金融市场的固有部分。 无论您是交易股票，期货，商品还是外汇，您都将面临更大的价差。 当您请求市场订单时，您的订单将被转移到真实的金融市场。 输入订单时，市场价格可能已更改，因此您的订单可能会以新价格交易。 当市场剧烈波动时，点差可能会增加。 因此，当您在正常市场条件（例如发布非农业数据）之外进行交易时，请特别注意。",
    touchingcialts: "当市场急剧波动时，一旦触及止损价，系统可能会以市场价而不是您的止损价进行交易。 因此，我们不能保证您的订单将以特殊趋势的止损价进行交易。 有关详细信息，请参阅风险声明。",
    Positionlts: "锁仓保证金？",
    Lockedlts: "锁定头寸订单是指在同一账户中以相同数量持有相同商品的相反方向的多头头寸和空头头寸的交易合约。",
    occupancym: "确定锁定后，客户帐户中的占用裕度为0。",
    investmentv: "锁仓交易会增加投资成本，在多头和空头合约上分别计算利息，直到相关合约平仓为止，我们公司不建议投资者采用这种策略。",
    wrongntv: "什么是错误的价格？",
    wpricing: "当由于银行间系统的报价错误（例如出现大利差或交易价格错误）而导致出现错误，遗漏，系统错误或显示不正确时，错误的定价错误。 BP Markets将对价格进行实时更正，由于系统错误，受错误价格影响的订单将在最短时间内恢复，错误价格将不被视为交易订单的依据。 （银行会将错误的价格订单的损益调整为零）。 由于错误导致的帐户余额，BP Markets将不承担任何责任。 以上内容并不包含所有情况，一旦报价执行错误发生，BP Markets保留纠正和调整有关报价和交易错误的纠纷的权利，并由BP Markets自行决定。 客户应同意赔偿BP Markets此类情况可能造成的损害或责任",
    pendingdng: "挂单/限价/止损/止盈订单的市场缺口安排？",
    profitng: "如果市场波动中没有客户设定的价格，则该公司现有未平仓合约的挂单/限价单和止损/止盈/止盈/止盈/止盈/止盈/止盈 点差，挂单将以缺口后的第一个价格出售； 如果当前价格和前一个价格之间的价格差小于平台产品价差，则将以客户的默认价格执行挂单。",
    pServicerofitng: "用户注册使用协议",
    PrivacyPolicy: "隐私政策",
    Disclaimer2v: "免责声明",
    disclosurebv: "风险披露手册",
    trustsurebv: '感谢您对 Parklife Capital Group Co., Ltd（以下简称“BP Markets”或“我们”）的信任与支持。我们充分理解个人信息对您的重要性，并致力于保护个人隐私。根据我们开展业务所在国家/地区普遍适用的隐私和数据保护法律法规及原则，采取适当的安全保护措施，以确保您个人信息的安全。',
    affiliatesebv: '本隐私政策规定了本公司及关联公司如何收集、使用、披露和保护您在使用我们服务时提供给我们的个人信息，我们将严格遵守本隐私政策的条款使用这些信息。',
    aproductsbv: '在使用我们的产品和服务之前，请务必仔细阅读并理解本政策，并在确认充分理解并同意后再使用相关产品和服务。使用我们的产品或服务，即表示您理解并同意本政策，并同意我们根据本政策合法使用和保护您的个人信息。',
    acollectbv: '1. 我们收集哪些个人信息？',
    ausingtbv: '在使用我们服务的过程中，我们会收集您提供或因使用服务而产生的信息，以优化我们的服务并确保您的账户安全。如果没有这些个人信息，我们无法向您提供该服务。',
    registeringe: '(1) 在注册账户或申请开立基金账户过程中提供的信息，例如：',
    gendernge: '① 身份信息（如姓名、性别、婚姻状况、出生日期、身份证号/护照号、国籍、地址、联系方式、电子邮件、税务管辖区等）及相应证明资料；',
    gCareerernge: '② 职业信息（如行业类别、职位、薪资、工作单位、单位地址等）及相应证明资料；',
    annualnge: '③ 资产信息（如收入来源、年净收入、流动资产净值、银行信用记录、存款余额及其他资产）及相应证明资料；',
    experiencenge: '④ 投资经验（如投资年限、投资工具、交易历史、投资偏好等）；',
    obtainedv: '(2) 您使用我们提供的服务时获取的信息，例如：',
    uniquedv: '设备信息（如您的设备型号、操作系统、唯一设备标识符、登录IP地址、操作日志等）；',
    duringv: '(3) 通过我们的系统进行交易和存取款过程中获取的信息。',
    dbankuringv: '① 存取款信息（如银行卡信息、金额信息等）',
    danalysisngv: '② 交易信息（如交易信息、账户信息、账户盈亏分析等）',
    additionalngv: '(4) 我们还可能收集关于您的其他信息，以便提供服务并提高服务质量，包括您联系我们的客服团队时提供的信息、参与问卷调查时向我们发送的问卷回复信息，以及您使用过的移动应用程序（APP）的相关信息。',
    authorizengv: '当您使用我们的产品或服务时，您授权我们基于实际业务和合作需求，从我们的关联公司接收、汇总和分析我们的个人信息或交易信息，确认其来源合法或您已授权同意。',
    authorizegv: '如果您拒绝提供上述信息或拒绝授权，您可能无法使用我们及关联公司的产品或服务，或可能无法显示相关信息。',
    rightgv: '如果您是欧盟用户，您有权要求我们根据《通用数据保护条例》(GDPR) 限制您的个人数据。我们将根据您的限制请求进行评估。如果符合 GDPR 规定，我们将根据条例中适用的具体条件处理您的数据，并在取消限制前通知您。',
    ripersonal: '2. 我们如何收集个人信息？',
    followingal: '我们在以下情况下收集您的个人信息：',
    processngal: '(1) 在申请账户或使用 BP Markets 网站/客户端产品应用程序的过程中；',
    vfsngal: "(2) 当您通过 BP Markets 系统进行交易并使用 BP Markets 关联公司提供的服务时：",
    openvfsngal: "① 当您根据申请为自己开立账户时；",
    managementvf: "② 监控您的账户交易并进行风险管理；",
    needvf: "③ 当您需要通过电汇提供您的联系方式时；",
    neservicesedvf: "④ 当您根据授权提供账户管理服务时；",
    ndepositedvf: "⑤ 当您的账户发起存款或提款时；",
    rghedvf: "⑥ 当我们执行客户尽职调查程序时；",
    rwqghedvf: "⑦ 当我们执行反洗钱和反恐怖融资程序时；",
    mkrwqghedvf: "⑧ 当我们履行报告、披露或遵守合规义务时。",
    mkrwfrqghedvf: "(3) 通过网络 Cookie 等方式收集。",
    fdhedvf: "(4) 根据法律和法规要求需要收集您个人信息的其他情形。",
    yfdhedvf: "3. 我们如何使用个人信息？",
    thyfdhedvf: "(1) 我们将您的个人信息用于以下目的：",
    qewthyfdhedvf: "① 用于改进我们向您提供的产品或服务，包括通过设备或网站提供的客户支持和服务。向您发送服务状态通知、营销活动和其他商业电子信息。",
    ujhedvf: "② 实施或协助其他机构进行信用审查；",
    bgujhedvf: "③ 开展相关的推广和促销活动。",
    bgujheddfdgvf: "④ 统计我们产品和服务的使用情况，以更好地改进我们的产品；",
    bthmkdfdgvf: "⑤ 为我们的运营及遵守各国适用法律法规而存储关于您的信息。",
    qwekdfdgvf: "⑥ 预防或禁止违反法律法规的活动。",
    bgqwef: "⑦ 为了更好地为您服务，防止您使用我们相关服务产生的风险或确定违约责任，我们可能通过第三方机构查询验证您的相关信息（例如是否为政治敏感人士、是否有犯罪记录等）。",
    pbgbgqwef: "⑧ 为了保护其他客户、我们或我们的集团公司、其他用户或员工的个人和财产安全或合法权益的合理必要使用。",
    requestwef: "如果您不希望我们将您的个人信息用于推送等目的，您可以通过我们在推送消息中提供的提示或特定产品/服务中提供的指引，要求我们停止将您的个人信息用于上述目的。",
    sfrequestwef: "根据适用法规，我们可能会根据业务需要将您的个人信息存储在其他国家或地区的数据中心。不同司法管辖区可能提供也可能不提供与您所在司法管辖区类似的数据保护法律。但是，这并不会改变我们根据本隐私政策保护您个人信息的承诺。",
    fddgdwef: "您与我们的关系终止后，我们将保留您的部分个人信息，这将受到国家法律法规的要求。如果出于诉讼、调查和司法程序的目的需要保留您的个人信息，保留时间将会延长。",
    automatedwef: "对于欧盟用户，我们不会根据 GDPR 条款对您的数据进行用户画像等额外的自动数据分析。",
    ujjuef: "4. 我们与谁分享您的信息？",
    tgreef: "除以下情况外，我们不会向任何第三方披露您的个人信息。如果需要公开披露，我们将告知您公开披露的目的、披露信息的类型以及可能涉及的敏感信息，并获得您的明确同意：",
    rftwgreef: "① 我们将在我们内部、本地及海外分支机构和关联公司的许可使用范围内处理您的个人信息。② 我们可能会向我们的第三方供应商（快递、法律服务、会计服务、金融风控）披露您的个人信息。③ 为了判断您的账户或交易是否安全或合规，我们将与金融风险防范领域的服务提供商、咨询机构、监管机构等共享您的个人信息。④ 根据国家法律，我们可能会按照法律要求与警方、法院、监管机构或律师共享您的个人信息。⑤ 如果我们与第三方开展联合推广活动，我们可能会共享完成活动所必需的个人信息，例如参与活动的用户数量、中奖名单、中奖者联系方式等，以便第三方能够及时向您发放奖品（如有）。⑥ 随着我们业务的持续发展，我们可能会进行合并、收购、资产转让或类似交易，您的个人信息可能会作为此类交易的一部分进行转移。我们将在转移前通知您。",
    sfwgrgeef: "5. 关于您主动分享信息的提示",
    busfwgrgeef: "(1) 我们的产品和/或服务允许您不仅与您自己的社交网络分享您的信息，还可以与该产品和/或服务的其他用户分享您的信息。例如，您在我们的产品和/或服务中上传或发布的信息（包括您公开的个人信息）、您对他人的上传或发布信息的回复，以及与此类信息相关的位置数据和日志信息。使用我们产品和/或服务的其他用户也可能分享关于您的信息（包括位置数据和日志信息）。只要您不删除分享的信息，该信息将保留在公共领域；即使您删除了分享的信息，该信息仍可能被其他用户或我们无法控制的非关联第三方独立地缓存、复制或存储，或者被其他用户或此类第三方保留在公共领域。因此，请仔细考虑是否通过我们的产品和/或服务上传、发布和交流相关信息内容。在某些情况下，您可以通过联系我们请求从我们的产品和/或服务中删除或修改您的信息。(2) 某些个人信息因其特殊性可能被视为个人敏感信息，例如您的财务状况、收入来源、种族、宗教、个人健康和医疗信息。个人敏感信息相比其他个人信息受到更严格的保护。(3) 请注意，您在使用我们的产品和/或服务时提供、上传或发布的内容和信息（例如有关您照片的信息）可能会泄露您的个人敏感信息。您在使用我们的产品和/或服务时需要仔细考虑是否披露相关的个人敏感信息。(4) 您同意我们可以按照本隐私政策中所述的目的和方式处理您的个人敏感信息。",
    thrgeef: "6. 我们可能向您发送的消息和信息",
    yeggeef: "(1) 邮件和信息通知",
    wdrgeef: "当您使用我们的产品和/或服务时，我们可能会使用您的信息向您的设备发送电子邮件、新闻或推送通知。如果您不希望收到此类信息，您可以按照我们的提示在设备上选择退订。",
    wereef: "(2) 与产品/服务相关的公告",
    vgwereef: "必要时（例如，因系统维护暂停某项服务时），我们可能会向您发出与产品和/或服务相关的公告。您可能无法取消这些与产品/服务相关且非广告性质的公告。",
    mireef: "7. 您如何管理您的个人信息？",
    hyuuuf: "(1) 访问您的个人信息",
    rehyuuuf: "① 除法律法规规定外，您有权访问您的个人信息。② 您可以通过登录账户访问和更新您的基本信息、登录密码、交易密码、绑定手机和邮箱地址。③ 您可以在我们的网站和应用程序上查看您的交易历史。",
    tyrehyuuuf: "如果您无法访问上述信息，可以联系客服，我们将响应您的访问请求。如果您是欧盟用户，您将有权根据 GDPR 条款要求我们检索您的个人数据并将其传输给其他数据控制者。",
    nhyruuf: "(2) 修改您的个人信息",
    qweuf: "您可以通过“访问您的个人信息”中列出的方式更正或补充您的个人信息。",
    bgqweuf: "(3) 删除您的个人信息",
    bgqweufbg: "在以下情况下，您可以要求我们删除您的个人信息：",
    mkiyufbg: "① 我们对您个人信息的处理违反法律。② 我们未经您的明确同意收集和使用您的个人信息。③ 我们对个人信息的处理严重违反了您协议的条款。④ 如果您是欧盟用户，您有权根据 GDPR 条款要求我们删除您的个人数据。",
    kuytyufbg: "(4) 保护您的个人信息",
    gtetyufbg: "① 您可以通过使用复杂密码并且不向任何人透露您的登录密码或账户信息来保护您的个人信息。一旦您的账号和密码泄露，可能会给您带来法律后果。如果您发现您的账号和密码因任何原因已经或将要泄露，请立即联系我们的客服，以便我们采取适当措施。但是，在合理时间内我们采取行动之前，我们对任何此类情况不承担责任。② 当您登录我们的网站或应用程序时，尤其是在公共设备上，应在会话结束后立即点击退出按钮注销登录。③ 由于您未能保护个人信息的隐私而导致第三方访问您的个人信息所造成的任何损失，我们概不负责。如果您发现任何未经授权使用您账户的情况或其他安全漏洞，您必须立即通知我们。④ 您的协助将有助于我们更好地保护您的个人信息。",
    grtiuyufbg: "8. GDPR 涵盖的个人的更多权利或信息",
    mktiuyufbg: '如果您的个人信息位于欧洲经济区（“EEA”），您将享有受《通用数据保护条例》（“GDPR”）保护的一系列与个人信息相关的法律权利。这些权利包括：',
    qwtmktiuyufbg: '(1) 获取有关您个人信息处理的信息，并访问我们公司保留的您的个人信息。请注意，在某些情况下，我们有权拒绝您访问您的个人信息副本（尤其是受法律专业特权保护的信息）；(2) 如果您的个人信息不准确或不完整，您可以要求我们进行更正，但如果您需要提供有效身份证件的副本以证明您身份信息的真实性，请一并提供；(3) 在某些情况下，您可以要求我们删除您的个人信息。请注意，在特定情况下（例如出于公共利益、公共卫生或科学历史研究目的），即使您要求我们删除，我们仍有权保留您的个人信息；(4) 在某些情况下，您反对我们处理您的个人信息，并要求我们限制对您个人信息的处理。同样，在某些情况下，即使您反对或要求我们限制处理您的个人信息，我们也有权拒绝您的请求；(5) 撤回您的个人信息许可。如果存在其他合法法律原因，我们也有权在未经您许可的情况下继续使用或处理您的信息。',
    mkiiuyufbg: '根据 GDPR 条款，除了提供系统性的个人数据保护方法外，我们还设立了数据保护官（DPO），全面负责您的数据保护工作。',
    ukiyufbg: '我们将评估收到的所有请求和投诉，并及时向您提供答复。我们可能会要求您提供有效身份证件的副本，以便我们履行安全义务并防止未经授权的数据披露。如果您对数据的访问请求明显无根据或超出常规，或者您要求我们提供额外的个人信息副本，我们保留向您收取合理管理费的权利。',
    miukiyufbg: '对于受 GDPR 保护的个人信息，我们可能会出于特定许可目的将您的个人信息传输到 EEA 之外。我们将确保任何此类国际传输都受到 GDPR 或其他相关法律的适当保护。',
    ghyiyufbg: '9. 信息安全',
    rewqfbg: "(1) 我们致力于保护您个人信息的安全，防止信息丢失、篡改、披露和不当使用。我们将采取多种安全措施，在合理的安全水平下保护您的信息。(2) 我们只会在本隐私政策所述目的及法律法规允许的时间内保留您的个人信息。(3) 为了保护您的信息安全，我们将在当前技术状态下采取合理必要的措施保护您的信息，并采用物理、技术和管理安全措施来降低丢失、误用、未经授权访问、披露和变更的风险，包括但不限于传输层数据加密、防火墙和加密存储、物理访问控制以及信息访问授权控制。我们已建立安全程序以保护您的信息免受未经授权的访问。例如：您与我们所有网络的通信，我们都确保使用加密技术 (SSL) 进行加密保护。您的个人信息在我们的服务器上使用高强度加密进行加密存储。请您理解并明白，即使我们尽最大努力采取上述措施，由于各种不可预测或无法预见的恶意方式，您的信息仍有可能被泄露、破坏或丢失。(4) 我们已建立专门的管理制度、流程和组织来保护您的信息。例如，我们严格限制企业内部可以访问信息的人员范围。所有员工均签署保密协议，独立安全组织定期审计。我们开展安全和隐私保护培训课程，以增强员工保护个人信息重要性的意识。(5) 如果您是欧盟用户，除了提供系统性的个人数据保护方法外，我们还将设立数据保护官 (DPO) 负责您的数据保护。(6) 不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将通过邮件、信函、电话、推送通知等方式告知您。难以逐一告知个人信息主体时，我们会采取合理有效的方式发布公告。同时，我们将按照监管部门要求，上报信息安全事件的处置情况。",
    mkrewqfbg: "10. 我们如何使用 Cookie？",
    qthwqfbg: "(1) Cookie 是由 Web 服务器创建并存储在用户浏览器上的小型文本文件。当用户访问 Web 服务器时，网站可以访问 Cookie 信息。Cookie 除了用于识别用户外，还可用于存储用户信息和跟踪用户访问行为。(2) 除了使用 Cookie 确认用户身份和登录状态外，我们不收集和跟踪用户的任何信息和行为。(3) 您可以根据自己的偏好管理和删除 Cookie。大多数浏览器都具有在系统中禁用或删除 Cookie 的功能。需要注意的是，阻止 Cookie 可能导致我们网站或系统的某些功能无法操作或无法使用，这可能会影响您的体验。",
    hytqfbg: "11. 本隐私政策的更新",
    appropriatebg: "我们将根据需要更新本指南的修订，以反映我们处理您个人信息的方式的变化或法律要求的变化。如果我们对隐私政策做出此类更改，我们将在官方网站上发布或以其他方式发布修订后的政策。更改自发布到我们网站之时起生效。",
    mjuyiatebg: "我们鼓励您定期查看此页面，以获取有关我们隐私指南的最新信息。您继续使用我们的产品和网站上提供的服务将被视为同意更新后的隐私政策。",
    bgtebg: "用户注册使用协议",
    bGroupgtebg: "本协议（“协议”）管辖客户与 BP Markets 之间的关系。如果本协议与 BP Markets 指定网站提供的内容存在任何不一致，以本协议为准。除非 BP Markets 的管理人员书面提出，否则不得更改或放弃本协议。客户不得更改或放弃本协议的任何部分。客户确认，BP Markets 可以通过电子邮件或客户登录的方式发出协议变更通知后更改本协议。客户收到上述通知后继续使用 BP Markets 的服务即视为其接受变更后的协议。在使用 BP Markets 平台服务之前，客户应仔细阅读本协议，并在遵守本协议所有条款后方可成为 BP Markets 的客户。一旦使用 BP Markets 平台的功能，客户即与 BP Markets 形成协议关系，并受本协议约束。",
    mkigtebg: "1. 风险提示",
    rtmkigtebg: "俗话说：“股市有风险，投资需谨慎”。投资证券存在潜在亏损的可能性。任何证券的历史数据都不能保证其未来表现或回报。客户的投资收益或亏损无法得到保证，尤其是在市场低迷时期。外国市场的证券交易具有投机性，风险很高。此外，在正常交易时间之外存在特殊的交易风险，包括低流动性风险、高波动性风险、价格变动风险、市场无法连接风险，以及影响价格的新闻发布和较大点差风险。客户应充分了解并理解证券交易的相关风险。在开立账户前，应根据自身经济实力、资金来源和风险承受能力，以理性人的立场对拟交易的 investment 对象和投资金额做出客观判断和自主决定。",
    hyigtebg: "BP Markets 及其相关方的董事、员工和代理不以任何明示或暗示的方式完全保证与证券交易相关的信息的真实性、充分性、及时性、可靠性、完整性和有效性。BP Markets 提供的所有信息、数据和资料仅供参考。客户应认识并接受通过 BP Markets 平台进行的交易并非没有风险。交易产生的风险应由客户承担。BP Markets 不对客户的投资风险和损失负责。",
    yhjubg: "2. 不提供投资、税务或交易建议",
    nhuyhjubg: "BP Markets 的代表或员工无权提供投资、税务或交易建议，也无权招揽订单。BP Markets 的网站、产品、社区和通讯组中的任何内容均不是购买或出售证券或其他投资的推荐或招揽。",
    yhkiubg: "开立账户",
    mkikiubg: "客户授权 BP Markets 根据本协议指示以其名义开立并维护一个或多个账户。",
    tuimkikiubg: "(2) 客户资格",
    koiikiubg: "1. 客户应为符合本协议相关交易法律法规要求的合格投资者：",
    tykoiikiubg: "① 自然人：客户年满 18 周岁，具有完全民事权利能力和民事行为能力，并拥有足够的知识和经验来理解拟交易产品的性质和风险。② 法人组织：客户完全具备法人主体资格，具有完全民事权利能力和民事行为能力。计划开立账户的人员是该法人组织的法定代表人或拥有该法人合法有效的授权。计划下达指令的人员拥有该法人合法有效的授权，并具备足够的知识和经验来理解拟交易产品的性质和风险。",
    hyuukiubg: "2. 在 BP Markets 平台服务的注册、开立账户和使用期间，客户应提供其真实资料和信息，并保证在此期间提交的所有资料和信息（包括但不限于电子邮件地址、电话、地址、邮政编码、身份证信息和信用信息）真实、准确、完整且为最新。如果客户的上述信息发生变更，客户应及时书面通知 BP Markets。客户授权 BP Markets 进行任何调查以核实上述信息。",
    yuijkiubg: "3. 若不符合上述条件，客户应立即停止使用本协议项下的服务。",
    olpokiubg: "4. 客户的订单/交易义务",
    okpolpokiubg: "客户承认，BP Markets 不知道使用客户用户名/密码输入订单的人是否为客户本人。除非 BP Markets 得到通知并同意，否则客户不允许任何人访问客户的账户。客户负责其用户名/密码的保密和使用，并同意在发生此类用户名/密码被盗/丢失或任何未经授权访问客户账户时，立即通过电话或电子邮件向 BP Markets 报告。客户仍对使用其用户名/密码输入的所有交易负责。",
    polipokiubg: "5. 订单传输",
    bhuopkiubg: "除非另有指示，BP Markets 将选择接收客户订单的市场/交易商。对于在多个市场交易的产品，BP Markets 或其合作伙伴可能会提供“智能路由”，通过计算机算法为每个订单寻找最佳市场。客户应选择可用的智能路由。BP Markets 无法保证每个订单都能以最佳报价执行：BP Markets 可能无法访问每个市场/交易商；其他订单可能抢先交易；市场中心可能不遵守报价或可能重新路由订单进行人工处理；或者市场规则、决策或系统故障可能阻止/延迟客户订单的执行或导致订单无法获得最佳价格。",
    myuuubg: "6. 订单取消/修改",
    eqmyuuubg: "客户承认，取消/修改订单可能无法实现，并且即使有取消/修改请求，客户仍对执行结果负责。",
    hukeqmyuuubg: "7. 订单执行",
    poouuubg: "BP Markets 应作为代理执行客户的订单，并可以进一步委托另一经纪商或子公司的代理代为执行客户的订单，在此情况下，被委托的经纪商或子公司享有与 BP Markets 相同的权利。BP Markets 可自行决定随时拒绝客户的任何订单或终止客户使用 BP Markets 的服务。所有交易均应遵守相关市场或清算所的规则和政策以及适用法律法规。BP Markets 对任何交易所、市场、交易商、清算所或监管机构的任何行动或决定不承担任何责任。",
    Confirmation: "确认",
    qwConfirmation: "(1) 客户承认，执行或取消的确认可能会延迟或出现错误（例如，由于计算机系统问题），或者可能被交易所取消/调整。如果与实际订单执行一致，客户受实际订单执行的约束。如果 BP Markets 错误地确认执行或取消，并且客户延迟报告此类错误，BP Markets 保留自行决定从账户中删除该交易或要求客户接受该交易的权利。",
    tyuation: "(2) 客户同意在以下情况下立即通过电话或电子邮件通知 BP Markets：",
    kityuation: "① 客户未能收到准确的执行或取消确认；② 客户收到的确认与其订单不同；③ 客户收到未下订单的确认；④ 客户收到反映不准确订单、交易、余额、头寸、保证金状况或交易历史的账户报表、确认或其他信息。客户承认 BP Markets 可以调整客户的账户以纠正任何错误。客户同意立即将错误分配给客户的任何资产返还给 BP Markets。",
    Margin: "保证金",
    rtyMargin: "1. 保证金交易风险：保证金交易风险极高，可能导致资金损失超过客户存入账户的金额。客户声明其已阅读 BP Markets 或其合作伙伴单独提供的《保证金交易风险披露》。2. 持续维持足够保证金的要求：保证金交易受交易所、清算所和监管机构的初始及维持保证金要求以及 BP Markets 的任何额外保证金要求（可能更高）的约束（“保证金要求”）。BP Markets 可随时自行决定修改任何或所有客户的任何未平仓或新头寸的保证金要求。客户应监控其账户，以便账户始终包含足够的资产以满足保证金要求。如果账户资产不足以满足保证金要求，BP Markets 可能拒绝任何订单，并可能在确定保证金状态时延迟处理任何订单。客户应在无需通知或要求的情况下，始终维持足够的资产以持续满足保证金要求。BP Markets 网站上计算保证金要求的公式仅供参考，可能无法反映实际的保证金要求。客户必须始终满足 BP Markets 计算的任何保证金要求。3. BP Markets 不会发出追加保证金通知：BP Markets 在根据本协议行使其权利之前，无需通知客户未能满足保证金要求。客户承认 BP Markets 通常不会发出追加保证金通知；通常 BP Markets 不会将资金存入客户账户以弥补日内或隔夜保证金不足；并有权在无需事先通知的情况下清算账户头寸以满足保证金要求。4. 头寸和抵销交易",
    qwrtyMargin: "① 如果任何时候客户的账户资产不足以满足保证金要求或出现赤字，BP Markets 有权（但无义务）自行决定随时以任何方式通过任何市场或交易商，在无需事先通知或向客户发出追加保证金通知的情况下，清算客户任何 BP Markets 账户（个人或联合）中的全部或任何部分头寸。客户应负责并立即向 BP Markets 支付因该清算而产生或清算后仍存在的客户账户中的任何不足。BP Markets 对客户因此类清算（或 BP Markets 系统延迟执行或未执行此类清算）而遭受的任何损失不承担责任，即使客户以更差的价格重新建立头寸。",
    kiuyMargin: "② BP Markets 可能允许客户在发生保证金不足时预先请求清算顺序，但此类请求对 BP Markets 不具有约束力，BP Markets 保留自行决定清算资产以及清算顺序/方式的权利。BP Markets 可以通过任何市场或交易商进行清算，BP Markets 或其关联公司可以根据法律法规进行交易的对手方交易。如果 BP Markets 清算客户账户中的任何/所有头寸，此类清算应确定客户的收益/损失以及（如有）对 BP Markets 的剩余债务。客户应就 BP Markets 进行的任何此类交易相关的所有作为、不作为、成本、费用（包括但不限于律师费）或责任对 BP Markets 进行补偿并使其免受损害。如果 BP Markets 执行了客户没有足够资本的订单，BP Markets 有权在不通知的情况下清算该交易，客户应对任何由此产生的损失负责，并且无权获得任何由此产生的利润。",
    uiMargin: "③ 如果 BP Markets 因任何原因未清算保证金不足的头寸，并发出追加保证金通知，客户必须立即存入资金以满足该通知要求。客户承认，即使发出了追加保证金通知，BP Markets 仍可能随时清算头寸。",
    tykrgin: "④ 客户承认，BP Markets 还有权在不事先通知的情况下清算客户的全部或部分头寸：",
    gthrgin: "(i) 如果就任何客户交易发生任何争议；(ii) 发生下文第 16 条所述的任何“违约事件”；(iii) 只要 BP Markets 认为清算对于保护 BP Markets 是必要或适宜的。",
    nygthrgin: "10. 联合账户",
    bgyhrgin: "每位联合账户持有人同意，每位联合持有人有权在不通知另一方的情况下：(i) 买卖证券（包括保证金交易）；",
    mkityrgin: "① 买卖证券（包括保证金交易）；② 接收账户确认书和通信；③ 接收和处置资金、证券或其他资产；(iv) 签订、终止或同意修改本协议；④ 放弃本协议的任何部分；⑤ 与 BP Markets 进行交易，如同每位联合持有人是唯一持有人。向任何联合持有人发出的通知构成向所有联合持有人发出的通知。每位联合账户持有人对 BP Markets 承担所有账户事项的连带责任。BP Markets 可以遵循任何联合持有人的指示，并将任何账户财产单独交付给任何联合账户持有人。⑥ 任何联合持有人死亡后，存活的持有人应通过电话或电子邮件通知 BP Markets，BP Markets 可以在通知之前或之后，自行决定启动程序、要求文件、保留资产和/或限制交易，以保护自己免受任何责任或损失。任何已故联合账户持有人的遗产应承担责任，每位幸存者应对 BP Markets 承担账户中或账户清算时的任何债务或损失的连带责任。除非客户另有说明，BP Markets 可假定账户持有人是具有生存权联权共有（joint tenants with rights of survivorship）的。任何联合持有人死亡后，账户应归属于存活的持有人，但绝不免除已故联合持有人遗产的责任。",
    miprgin: "11. BP Markets 账户的多币种功能",
    jytgin: "(1) 客户或许能够使用客户选择的基础货币交易以不同货币计值的产品。当购买以不同于基础货币的货币计值的产品时，会创建保证金贷款来为购买提供资金，并以客户账户中的资产作为担保。如果客户持有外币计值的头寸，BP Markets 将通过应用 BP Markets 指定的汇率来计算保证金要求。BP Markets 将应用“折减”（外币资产金额的百分比折扣）以反映基础货币与外币之间汇率波动的可能性。客户必须始终密切监控保证金要求，特别是对于以外币计值的头寸，因为货币和基础头寸价值的波动可能导致保证金不足。",
    poigin: "(2) 客户同意，BP Markets 对客户的义务应以以下货币计值：",
    mukpoigin: "① 美元；② 客户存入资金或应客户要求兑换的货币（在此类存款和兑换的范围内）；③ 因在指定合约市场或注册衍生品交易执行设施上进行交易而累积给客户的资金货币（在此类累积的范围内）。",
    mkpmukpoigin: "12. 外币兑换（简称“外汇”）",
    puyykpoigin: "(1) 外汇交易高风险：外汇交易通常不受监管。由于涉及杠杆（保证金），其风险极高，由此产生的财务损失可能超过客户存入账户的资金。客户确认 BP Markets 提供的《外汇交易和多币种账户风险披露声明》。",
    lpoigin: "(2) 对于外汇交易，BP Markets 通常作为代理或无风险实体收取费用。BP Markets 可能通过其分支机构或第三方进行外汇交易，上述分支机构或第三方可能从上述交易中获利或承担损失。客户同意 BP Markets 可以将任何资金或资产转移或转入客户的受监管期货或证券账户，从客户的任何不受监管的外汇账户转入或转出，以避免追加保证金通知、减少借方余额或出于任何其他法律原因。",
    poolgin: "(3) 净额结算：",
    muipoolgin: "① 通知净额结算的债务更新。客户与 BP Markets 之间的每笔外汇交易将立即对客户与 BP Markets 之间以相同货币进行的所有现有外汇交易进行净额结算，形成一笔交易。② 支付净额结算。如果在任何交割日，要交割的一种货币存在多个到期日，各方应计算要交割的总金额，并仅交割差额。③ 终止净额结算。如果客户：(a) 在任何 BP Markets 账户中出现保证金短缺；(b) 对 BP Markets 的任何义务违约；(c) 进入破产或其他类似程序；(d) 未能支付到期债务，BP Markets 有权（但无义务）终止客户的外汇交易，清算客户的全部或部分抵押品，并使用收益支付对 BP Markets 的任何欠款。终止净额结算或任何“违约”后，所有未平仓外汇交易将被视为在该事件、申请或诉讼触发之前已经终止。⑤ BP Markets 的权利附加于 BP Markets 所拥有的任何其他权利（无论是通过合同、法律等）。",
    rgyoglgin: "(4) 本合同中的任何内容均不得视为 BP Markets 承诺提供一般外汇交易或签署任何特定外汇交易。BP Markets 保留无限制地拒绝任何外汇交易订单或拒绝任何货币的双向市场报价的权利。",
    koplgin: "13. 卖空",
    shortlgin: "客户承认，卖空必须在保证金账户中进行，并受保证金要求的约束；在卖空之前，BP Markets 必须相信其可以借入股票用于交割；并且如果 BP Markets 无法借入股票（或在召回通知后无法重新借入），BP Markets 可以代表客户买入股票（无需通知客户），以回补空头头寸，客户对任何损失/费用负责。",
    poiflgin: "14. BP Markets 贷款/质押客户资产的权利",
    koigin: "BP Markets 和客户可能不时进行一方将某些证券借给另一方的交易。本文中每项此类交易均称为“贷款”。在相关监管要求允许的情况下，客户授权 BP Markets 为卖空或其他目的将自己或其他客户的证券或资产贷出。",
    lpoikoigin: "15. 担保权益",
    kpioigin: "BP Markets 为或代 BP Markets 为客户账户持有的所有种类的资产特此质押给 BP Markets，并受以 BP Markets 为受益人的完善的优先留置权和担保权益的约束，以担保根据本协议或任何其他协议对 BP Markets 产生的义务和责任的履行。",
    piiuigin: "16. 违约事件",
    tgyhgin: "(1) 以下情况将自动发生“违约”，无需通知：(i) 客户违反/否认与 BP Markets 的任何协议；(ii) 客户在 BP Markets 自行决定提出要求后，未能提供令 BP Markets 满意的履行义务的保证；(iii) 根据任何破产、资不抵债或类似法律对客户提起或由客户提起的程序；(iv) 为客户债权人的利益进行转让；(v) 为客户或客户财产指定接管人、受托人、清算人或类似官员；(vi) 客户陈述在作出时不真实或具有误导性，或之后变得不真实；(vii) 客户法律上无行为能力；(viii) 任何监管机构或组织启动暂停客户业务或许可的程序；(ix) BP Markets 有理由认为上述任何情况很可能即将发生。",
    plotgyhgin: "(2) 客户无条件同意，一旦发生违约，BP Markets 可以终止 BP Markets 对客户的任何或全部义务，并且 BP Markets 有权（但无义务）自行决定在无需事先通知的情况下，随时以任何方式通过任何市场或交易商清算客户在任何 BP Markets 账户（个人或联合）中的全部或任何部分头寸。客户应就任何客户违约或 BP Markets 在违约时进行的任何交易相关的所有作为、不作为、成本、费用（包括但不限于律师费）或责任对 BP Markets 进行补偿并使其免受损害。",
    eyygin: "17. 可疑行为",
    tgkeyygin: "如果 BP Markets 自行认为客户账户涉及任何欺诈或犯罪、违反法律法规、或被非法访问、或以其他方式涉及任何可疑活动（无论是受害者还是肇事者或其他），BP Markets 可以暂停或冻结该账户或该账户的任何特权，可以冻结或清算资金或资产，或者可以对“违约”使用本协议中的任何补救措施。",
    pereyygin: "18. 非现金结算的商品期权和期货",
    rewygin: "客户确认：(A) 商品期权不能行权，必须通过对冲平仓；以及 (B) 不通过现金结算进行实物交割的期货合约（包括 BP Markets 可交割货币清单上的货币以外的货币），客户不得进行或接受交割。如果客户在 BP Markets 或其合作伙伴网站上公布的最后期限之前未对冲商品期权或实物交割期货头寸，客户授权 BP Markets 转让、平仓或清算由期权或期货合约引起的任何头寸或商品，客户对所有损失/费用负责。",
    mpoewygin: "19. 佣金和费用、利息及资金",
    pqwergin: "除非 BP Markets 管理人员书面同意，否则佣金和费用以 BP Markets 网站上规定为准。客户承认 BP Markets 从客户账户中扣除佣金/费用，这将减少账户资产。如果佣金或其他费用导致保证金不足，头寸将被清算。佣金/费用的变更在 BP Markets 网站上发布或通过电子邮件或其他书面通知发送给客户后立即生效。BP Markets 应按照 BP Markets 网站上的利率和条款向客户支付贷方利息并收取借方利息。客户资金将在交易结算后才能 disbursed。存款和取款的条款和条件（包括持有期）以 BP Markets 网站上规定为准。",
    bgtergin: "20. 账户负余额",
    qvjtergin: "如果现金账户出现赤字，将适用保证金利率，直到余额还清，BP Markets 有权（但无义务）将该账户视为保证金账户。客户同意支付任何未付客户赤字的合理追收费用，包括律师和追收代理的费用。",
    pootergin: "21. 国外市场风险、盘后交易风险",
    qwpootergin: "客户确认，在外国市场进行证券交易具有投机性且风险很高。此外，在正常交易时间之外存在特殊的交易风险，包括低流动性风险、高波动性风险、价格变动风险、市场无法连接风险，以及影响价格的新闻发布和较大点差风险。客户声明其完全理解上述风险并有能力承担此类风险。",
    oiootergin: "22. 对证券、权证和公司行为的了解",
    lpoiootergin: "客户确认，其有责任了解其账户中任何证券的条款，包括即将发生的公司行为（例如，收购要约、重组、股票分割等）。BP Markets 没有义务通知客户截止日期或所需采取的行动或会议日期，BP Markets 也没有义务在没有客户通过 BP Markets 网站发送电子邮件发送的具体书面指示的情况下采取任何行动。",
    pllpoiootergin: "23. 报价、市场信息、研究和互联网链接",
    nhuotergin: "通过 BP Markets 可访问的报价、新闻、研究和信息（包括通过链接到外部网站）（“信息”）可能由独立提供商编制。该信息是 BP Markets、提供商或其许可方的财产，受法律保护。客户同意未经 BP Markets 或提供商的书面同意，不以任何方式复制、分发、出售或商业利用该信息。BP Markets 保留终止信息访问权限的权利。信息均不构成 BP Markets 的推荐或买入/卖出的招揽。BP Markets 和提供商均不保证信息的准确性、及时性或完整性，客户在做出投资决策前应咨询顾问。依赖报价、数据或其他信息风险自负。在任何情况下，BP Markets 或提供商均不对因使用信息而产生的间接、附带、特殊或从属损害承担责任。对于信息，不作任何明示或暗示的保证，包括适销性保证、特定用途适用性保证或不侵权保证。",
    potergin: "24. 使用 BP Markets 软件的许可",
    lpotergin: "BP Markets 授予客户非排他性、不可转让的许可，仅可按照本文规定使用 BP Markets 软件。BP Markets 软件和更新的所有权，包括所有专利、版权和商标，仍为 BP Markets 的独有财产。客户不得向他人出售、交换或转让 BP Markets 软件。除非 BP Markets 管理人员书面授权，否则客户不得复制、修改、翻译、反编译、逆向工程、反汇编或还原为人类可读形式，或改编 BP Markets 软件，或使用它创建衍生作品。对于违反这些承诺的行为，BP Markets 有权获得即时禁令救济。",
    mjhdgin: "25. 免责声明和违约金",
    thmjhdgin: "(1) 免责事项",
    qdrthmjhdgin: "①BP Markets 没有义务调查注册手机号码所有者的身份真实性，并且对使用被盗、欺诈性使用或滥用个人手机号码在 BP Markets 平台上注册账户所造成的任何损失不承担任何责任。②所有在 BP Markets 注册并开立账户的客户应遵守相关法律法规和 BP Markets 平台的使用规则，不得发布政治有害信息、色情内容、虚假广告、血腥暴力、侮辱或诽谤性评论、泄露个人隐私以及任何其他违反法律法规的信息，也不得从事侵犯第三方知识产权和其他合法权益的活动。否则，客户应承担由此产生的一切损失，BP Markets 不承担任何责任。③在任何情况下，BP Markets 均不对任何惩罚性、间接、偶然、特殊或相关的损失或损害承担责任，包括但不限于间接人身损害、商业利润损失、交易中断、商业信息损失或任何其他信赖利益损失。④由于投资证券或金融产品存在损失风险，BP Markets 不对与客户投资相关的损益和风险负责。⑤BP Markets 及其关联公司不能保证其提供的市场报价、图表、评论等信息绝对可靠和准确，也不对市场任何内容的不准确或缺失或客户主观因素造成的损失承担责任。⑥因互联网数据传输故障、中断、延迟或其他因素可能导致的交易指令中断、暂停、延迟或数据错误。⑦由于疏忽导致客户的交易账号和密码泄露或其身份被伪造。⑧由于互联网上可能存在恶意攻击、网络服务器可能出现故障和其他不可预测因素，市场信息和其他证券相关信息可能出现错误或延迟。⑨客户的网络终端设备和软件系统可能遭受非法攻击或病毒侵害，导致无法发出委托或委托失败。⑩客户的网络终端设备和软件系统与 BP Markets 的网上交易系统不兼容，导致无法发出委托或委托失败。在此情况下，客户可拨打 BP Markets 的电话报告情况并获取技术支持，但不能获得 BP Markets 的经济补偿。⑪因客户操作不当导致委托失败或委托故障。⑫因客户个人原因导致客户账号和密码、个人信息或交易信息泄露或其身份被伪造等情况造成的损失。⑬客户利用 BP Markets 提供的服务进行任何非法活动或侵犯他人权益的行为，从而给客户和第三方造成损失。⑭由于网络故障，当在 BP Markets 平台上操作时，客户的网络终端显示其委托成功，而 BP Markets 的交易服务器未收到客户的委托指令，从而导致客户无法买卖证券的风险；由于客户的网络终端显示其委托未成功，客户再次发送委托指令，导致 BP Markets 的交易服务器收到客户的两条委托指令并将该等指令传输给证券公司进行交易，从而产生客户重复交易的风险。⑮因法律政策重大变化或 BP Markets 无法预见和控制的因素导致的紧急情况。⑯由于战争、通信故障、自然灾害、罢工、政府部门行为等不可抗力导致 BP Markets 平台功能失效，造成客户经济损失。⑰BP Markets 的指定网站和产品将发布或传输其合作公司提供的新闻、信息等内容，并注明信息提供者。BP Markets 不对其合作公司提供的内容进行实质性审查或修改，也不保证其真实性，客户应自行判断，BP Markets 不对此负责。",
    loudgin: "(2) 违约金",
    poloudgin: "客户确认，在使用 BP Markets 系统期间可能会出现延迟或中断，包括因 BP Markets 故意维护其系统而产生的中断。在任何情况下，无论采取何种行动，也不论客户遭受何种损失，BP Markets 的责任均不超过事故发生前六 (6) 个月内客户向 BP Markets 支付的最高月佣金总额。",
    gypoloudgin: "26. 隐私保护",
    mloudgin: "(1) 根据法律监管要求，BP Markets 将收集客户的以下非公开信息：身份信息和就业信息、账户余额和账户交易历史、信用历史和投资经验。(2) BP Markets 将在以下情况下收集客户的个人信息：开立账户或进行交易、进行电汇时提供客户的联系方式、从客户账户存入或提取资金。(3) BP Markets 将根据客户的个人信息和资料、（隐私）条款及其他适用法律开展以下活动：向客户提供投资服务和产品的日常运营、进行信用调查或协助其他主管机构进行信用调查、确保客户维持良好信用、符合相关法律法规及行政主管机关的审查和披露要求。(4) 个人信息保护措施：BP Markets 将采取符合法律要求的安全措施，包括但不限于计算机安全防护、文件加密和安全办公大楼，以严格管理和保护客户的个人信息，防止未经授权的访问和使用，并保护客户的个人数据免遭丢失、被盗或篡改。(5) 除非法律法规要求，BP Markets 不会向第三方披露客户的个人非公开信息。BP Markets 仅在以下情况下披露客户的个人信息：为授权、完成、监控或执行客户要求或授权的交易所必需；维护和监控客户账户；向客户提供账户确认书、账户报表和记录；保持正确的案件记录；为履行我们的客户协议和其他协议所必需；为履行 BP Markets 的责任或保护 BP Markets 的权利和财产所必需；司法机构、行政机构和其他主管监管机构根据法律程序执法或法律监督；根据相关法律、法规或规则需要披露客户的个人信息。",
    mloudginb: "27. 客户维持替代交易安排",
    temloudginb: "BP Markets 使用的基于计算机的系统本质上容易受到中断、延迟或故障的影响。客户必须在 BP Markets 系统不可用时，除了其 BP Markets 账户外，维护替代交易安排以执行客户订单。通过签署本协议，客户声明其维护了替代交易安排。",
    kodginb: "28. 披露声明",
    followingb: "BP Markets 特此向客户作出以下声明：A) BP Markets 将确保客户资产从收到之时起受到保护，直至：(a) 证券的法定所有权已登记在客户名下，或已在相关发行人的证券登记册中以客户实益权益持有；或 (b) 客户明确指示 BP Markets，将存入我方用于向执行对手方转交以参与 IPO 的资金如此转交；B) 客户应知悉，一旦 BP Markets 破产，资产（包括客户能够确定追索的资产）将被返还、转让或分配给客户或其代表，可分配的资产金额将根据客户资产的比例分摊；C) 确定可追索的资产返还通知将在普遍发行的报纸上公布；D) 客户应为其账户中资金的实益所有人，并应确保资金的来源和使用合法，且存款和货币兑换程序符合客户管辖区的相关法律法规（包括但不限于新西兰和中国）。因客户资金的所有权和合法性产生的任何争议或任何相关处罚应由客户解决。如果因此给 BP Markets 造成任何损失，客户应全额赔偿 BP Markets。",
    juujngb: "29. 接受电子数据和通信的协议",
    mkjuujngb: "BP Markets 以电子形式向客户提供电子交易确认书、报表、税务信息以及其他客户记录和通信（“电子记录和通信”）。电子记录和通信可能会发送到客户的交易平台或客户的电子邮件地址，或出于安全原因发布在 BP Markets 的网站上，并通知客户登录和搜索上述通信。签署本协议即表示客户同意接收电子记录和通信。除非客户撤回其同意，否则上述协议持续适用，并在每个纳税年度适用。客户可以随时书面通知 BP Markets 其撤回同意。如果客户撤回同意，BP Markets 应根据客户通过电话或电子邮件的要求提供纸质税务文件。但是，BP Markets 保留要求客户关闭其账户的权利。",
    ukujngb: "通过 BP Markets 交易平台进行交易以及通过该交易平台接收电子记录和通信存在系统软件和硬件要求，这些要求在 BP Markets 网站 www.BP Marketsx.com 上进行了说明。由于上述要求可能会发生变化，客户必须定期访问 BP Markets 网站以了解当前的系统要求。要接收 BP Markets 的电子邮件，客户应保持有效的互联网电子邮件地址以及用于阅读、发送和接收电子邮件的电子邮件软件。当其电子邮件地址变更时，客户必须立即通过 BP Markets 网站上规定的更改客户电子邮件地址的程序通知 BP Markets 该变更。",
    Miscellaneous: "杂项",
    Miscgovernedus: "(1) 本协议受澳大利亚法律管辖，与本法律条款相冲突的协议条款无效。在所有司法行为、仲裁或争议的解决中，双方放弃任何损害赔偿的权利。(2) 争议解决：经双方协商一致，因客户使用 BP Markets 平台交易服务而产生的争议应优先通过协商解决。(3) 客户同意本协议条款以中文书写，并表明其理解本协议的条款。本协议包含双方达成的完整合同，任何一方不得在本协议之外作出其他声明或提供其他担保。本协议任何条款的不可执行性不应影响本协议其他条款的效力。BP Markets 未能履行本协议的任何条款不应被视为其放弃该等条款。(4) 客户同意 BP Markets 记录所有电话通话。客户承认 BP Markets 的隐私声明，并同意 BP Markets 根据 BP Markets 的规则收集/使用客户的信息。(5) 未经 BP Markets 事先书面同意，客户不得转让本协议项下的任何权利或义务。向客户发出通知后，BP Markets 可将本协议转让给另一经纪商、交易商或期货经纪商。本协议应保证 BP Markets 的继承人或受让人的利益。BP Markets 可随时终止本协议或终止向客户提供服务。客户可以通过电子邮件通知 BP Markets 并通过 BP Markets 网站关闭其账户，但前提是必须清算所有头寸并满足 BP Markets 网站上规定的关闭账户的所有其他要求。(7) BP Markets 享有解释和修改本协议的权利。如果本协议的任何条款因任何原因完全或部分无效或不可执行，本协议的其他条款应保持有效和具有约束力。(8) 本客户服务协议以英文和中文两种语言书写。如果中文版本与英文版本存在任何差异，以英文版本为准。",
    kivernedus: "我确认向 BP Markets 提交的个人身份信息、财产状况、投资经验和手写签名信息真实准确。我已了解并同意授权 BP Markets 使用上述材料开立个人证券账户，并在所有必要情况下及制作所有必要文件时使用该等材料，我愿受此约束。",
    Disclaimerft: "免责声明",
    mkiimerft: "1. BP Markets 没有任何义务审查注册手机号码所有者的身份真实性。如果个人手机号码被盗、被欺诈或用作 BP Markets 平台账户注册，BP Markets 不承担任何责任。",
    kiomerft: "2. 所有在 BP Markets 注册并开立账户的客户均须遵守相关法律法规及 BP Markets 平台的使用规则，不得在 BP Markets 平台（社区、通讯群组等）上发布任何政治有害、淫秽色情、虚假广告、血腥暴力、侮辱诽谤、侵犯个人隐私及其他违法违规信息，也不得从事侵犯第三方合法权益的活动，否则由此产生的一切损失由客户承担，BP Markets 不承担任何责任。",
    yuimerft: "3. 在任何情况下，BP Markets 均不对任何惩罚性、间接、偶然、特殊或结果性损失或损害承担责任，包括但不限于间接人身损害、商业利润损失、交易中断、商业信息损失或任何其他信赖利益损失。",
    qwyuimerft: "4. 投资证券或金融产品存在损失风险。BP Markets 不对客户的投资收益损失和风险承担任何责任。",
    yujmerft: "5. BP Markets 及其关联公司无法保证所提供的信息价格、图表、评论和其他信息绝对可靠和准确，也不对任何内容的不准确或遗漏或因客户主观原因造成的任何损失承担责任。",
    eryujmerft: "6. 因互联网数据传输故障、终端、延迟等原因，可能出现交易指令中断、暂停、延迟、数据错误等情况。",
    mkuerft: "7. 因客户的疏忽，交易账号和密码信息泄露，或其身份被伪造。",
    tymkuerft: "8. 由于互联网可能存在恶意攻击、网络服务器可能出现故障及其他不可预测因素，市场信息及其他产品信息可能出现错误或延迟。",
    iiktymkuerft: "9. 客户的网络终端设备和软件系统可能受到非法攻击或病毒侵害，导致无法发出委托或委托失败。",
    yhjmkuerft: "10. 客户的网络终端设备和软件系统与 BP Markets 提供的网上交易系统不兼容。无法发出委托或委托失败。客户可以拨打 BP Markets 电话报告情况并获取技术支持，但无法获得 BP Markets 的经济补偿。",
    yjkuerft: "11. 因客户操作不当导致委托失败或委托故障。",
    uiift: "12. 因客户个人原因导致账户密码、个人信息、交易数据泄露或客户身份被伪造造成的损失。",
    qwuiift: "13. 客户使用 BP Markets 提供的服务从事任何非法或侵犯他人权益的行为，给客户和第三方造成损失。",
    ryuqwuiift: "14. 由于网络故障，当客户通过 BP Markets 平台操作时，客户网络终端设备显示委托成功，而 BP Markets 交易服务器未收到委托指令，从而产生用户无法买卖的风险；客户网络终端设备显示委托未成功，因此客户再次发出委托指令，BP Markets 交易服务器收到客户的两条委托指令并将指令传递给证券公司进行交易，从而产生用户重复交易的风险。",
    vuiiift: "15. 法律法规政策的意外变化或 BP Markets 无法预见和控制的因素造成的意外事件。",
    veuiyift: "16. 由于战争、通信故障、自然灾害、罢工、政府部门行为等不可抗力导致 BP Markets 平台功能无法实现，造成客户经济损失。",
    uioyift: "17. 合作公司提供的新闻、信息和其他内容将在 BP Markets 的官方网站和产品中发布和转载。发布和转载时将注明内容提供者。BP Markets 不对其提供的内容进行任何实质性审查或修改，也不保证内容的真实性。请自行判断，BP Markets 不承担任何责任。",
    mkuioyift: "尊敬的交易者：",
    lopmkuioyift: "为了充分了解交易风险，本风险披露依据 BP MarketsX 运营管理办法相关规定提供。如果您选择参与交易所市场交易，即视为您已阅读本风险披露的前述条款，并自愿承担与交易相关的风险。",
    drfuioyift: "鉴于交易商投资于风险交易且可能导致交易商损失，请仔细考虑自身情况是否适合此类交易，并认清自身的风险和损失，同时客观、理性地了解交易风险，包括但不限于：",
    drkuytt: "一、宏观经济风险：",
    qwudrkuytt: "由于国家宏观经济形势的变化可能影响交易工具的价格上下波动；国际宏观经济形势的变化将对市场产生影响，可能导致交易工具价格上下波动的情况发生。",
    yuopytt: "二、政策法规及市场风险：",
    plopyuopytt: "做市交易作为一种创新的交易模式，其自身的交易规则需要在实践中不断完善，国家法律、法规、政策的变化以及其他影响价格波动的因素，可能影响交易工具的价格；或由于市场根据国家法律、法规、政策的变化而对交易市场的相关规则进行修订，可能影响交易主体资格及交易规则的变化。上述法律、法规、政策及交易所规则的风险可能导致本交易市场交易工具价格异常波动。",
    mytyuopytt: "三、交易风险。",
    thjoytt: "(1) 交易者需要了解做市交易具有投机性和风险性，可能导致盈利或亏损。如果开仓方向与市场波动相反，将造成较大损失。根据损失程度，交易商必须随时具备满足追加资金要求的条件，否则头寸将被强平，交易商必须承担由此产生的全部损失。",
    typytt: "(2) 在交易系统中，网上终端提交的市场价格是单一的，交易不可撤销。投资者必须接受这种方式可能带来的风险。",
    poyhtt: "(3) 交易市场、交易商及其工作人员不会对交易商做出盈利保证，也不会与交易商分享收益或分担风险。交易者应当知道，对做市交易的任何盈利保证或不会发生损失的承诺都是不可能且没有根据的。",
    qtbpoyhtt: "(4) 交易商的交易文件必须基于其自己的决定。本市场、交易商及其工作人员提供的任何市场分析及信息仅供参考，不构成任何要约。由此产生的交易风险由交易商自行承担。",
    hjupoyhtt: "(5) 在电子交易过程中，可能会出现明显的报价错误机会，本市场随后可能会纠正错误的价格以及由此产生的损益，由此产生的交易风险由交易商自行承担。",
    pooyhtt: "(6) 如果您缺乏网上交易经验，可能会导致交易不当或操作失误。",
    ptuiooyhtt: "四、技术风险：",
    uytiooyhtt: "交易过程中，信息的显示和资金的支付是通过使用电子通信技术和计算机技术实现的，并通过互联网传输，这些技术可能受到网络黑客和计算机病毒的攻击，或者通信技术、计算机技术及相关软件存在缺陷的可能性。互联网传输故障也可能导致您的交易指令无法及时传输。这些风险可能导致您的交易申报无法完成或无法全部交易，或转账资金无法及时到账、交易延迟、中断，甚至无法完成交易等。",
    tyuiyhtt: "五、不可抗力风险：",
    uiopiyhtt: "地震、台风、火灾、洪水、战争、瘟疫、社会动荡等不可抗力因素可能导致交易系统出现缺陷；本交易市场中无法控制和预测的系统故障、设备故障、通信故障、电源故障等也可能导致交易系统运行异常甚至瘫痪；银行无法控制和预测的系统故障、设备故障、通信故障、电源故障等也可能导致资金转账系统运行异常甚至瘫痪。这些风险可能导致您的交易申报无法完成或无法完全完成，或转账资金无法及时支付。",
    hyuyhtt: "六、账户密码泄露风险：",
    qwehyuyhtt: "由于密码泄露、账户泄露或交易商身份被他人使用计算机操作，可能导致用户无法正确发出申报指令、恶意虚假申报或申报失败、延迟、错误等。",
    yuiyhtt: "七、交易者软硬件系统风险：",
    thuitt: "交易者的计算机设备和软件系统与提供的网上交易系统不匹配，导致无法发出申报指令或申报失败、延迟等。",
    kpothuitt: "八、其他风险：",
    yjipptt: "密码丢失、操作不当、投资决策失误等可能导致交易者损失；网上申报、热键操作完成后未及时退出热键，以及他人恶意操作造成的损失；网上交易未及时退出也可能导致黑客攻击和损失。",
    werytptt: "上述所有风险可能导致交易者产生损失，损失均由交易者承担。当交易者参与本市场交易时，他人所做的任何盈利或不会亏损的承诺都是没有根据的。类似的承诺不会减少亏损的可能性。",
    tyuptt: "本风险披露不能揭示进行做市交易的所有风险。因此，在您投资本市场之前，应充分了解《BP MarketsX 运营管理办法》的交易规则和规定以及本风险披露声明，并结合自身的经济承受能力、风险控制能力、身心承受能力（仅限自然人交易客户）对包含在本风险之外的其他风险做出客观判断，审慎研究进行市场交易。一旦您选择在本市场交易，即视为您已充分理解并接受在本交易市场进行交易相关的制度、规则、方式以及交易中可能存在的风险。",
    endtyuptt: "郑重承诺：我勾选当前页面风险披露对应的复选框并点击“同意并继续”按钮，即表示我已仔细阅读上述风险声明，充分理解并同意，并自愿承担由此产生的任何风险及可能造成的所有损失。",
    endkiuy: "涵盖BTC、LTC、EHT、XRP等主流加密货币品种",
    hottestiuy: "当今最热的投资市场",
    uiystiuy: "相对较低的保证金",
    Richtiuy: "日内丰富的交易机会",
    mainstreamuy: "可交易BTC、LTC、ETH、XRP等主流加密货币",
    qeweg: "极富竞争力的数字币差价合约定价",
    dataqeweg: "Q1.数字币领域应该关注哪些数据或新闻事件？",
    Tradingg: "交易数字币合约主要关注全球的政治经济动态，以及美元的价格变化。",
    Notice: "通知",
    CFDtrading: 'CFD差价合约交易',
    CFDtmajorng: '以相对较低的保证金和费用交易加密货币等主要活跃市场和品种',
    ICOransaction: 'ICO币兑交易',
    Supportmajorng: '支持全球主流加密货币的币兑交易',
    OTCansaction: 'OTC场外交易',
    otcajorng: '支持各国法币与主流加密货币场外兑换',
    Blockchnsaction: 'Blockchain区块链钱包',
    Blockchjorng: '运用区块链去中心化技术，实现对资产的安全管理，便捷流通',
    // BPmarkets - Register page
    reg_welcome_title: '欢迎加入我们的团队',
    reg_current_merchant: '当前交易商',
    reg_phone_register: '手机号注册',
    reg_email_register: '邮箱注册',
    reg_country_region: '国家/地区',
    reg_select_country: '请选择国家/地区',
    reg_enter_phone: '请输入手机号',
    reg_enter_email: '请输入邮箱地址',
    reg_login_password: '登录密码',
    reg_enter_password: '请输入登录密码',
    reg_confirm_password: '确认登录密码',
    reg_re_enter_password: '请再次输入登录密码',
    reg_verification_code: '验证码',
    reg_enter_code: '请输入验证码',
    reg_get_code: '获取验证码',
    reg_invite_code: '邀请码',
    reg_enter_invite_code: '请输入邀请码',
    reg_agree_prefix: '我已阅读',
    reg_user_agreement: '《用户注册使用协议》',
    reg_register: '注册',
    reg_email: '邮箱',
    reg_phone: '手机号',
    reg_mainland_china: '中国大陆',
    reg_phone_required: '手机号码不能为空',
    reg_phone_format: '请输入正确格式的手机号码',
    reg_email_required: '邮箱不能为空',
    reg_email_format: '请输入正确的邮箱地址',
    reg_code_required: '验证码不能为空',
    reg_password_required: '请输入密码',
    reg_password_format: '密码长度为6-20位字母或数字',
    reg_confirm_password_required: '请再次输入密码',
    reg_password_mismatch: '两次密码不一致',
    reg_invite_code_required: '请输入邀请码',
    reg_invite_code_invalid: '邀请码无效',
    reg_please_agree: '请先勾选《用户注册使用协议》',
    reg_code_sent: '验证码已发送',
    reg_code_send_fail: '验证码发送失败',
    reg_code_too_frequent: '请求验证码发送过于频繁',
    reg_register_success: '注册成功',
    reg_register_fail: '注册失败',
    reg_country_load_fail: '获取国家列表失败',
    reg_china: '中国',
    // BPmarkets - Register success page
    regsuc_tips1: '恭喜，您已注册成功',
    regsuc_tips2: '请点击下方按钮下载BP Markets',
}


// WEBPACK FOOTER //
// ./src/common/lang/zh.js